import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPin = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.42599 10.8016C5.55857 10.8047 5.68449 10.8603 5.77608 10.9562L8.62572 13.9404C8.70044 14.0186 8.74776 14.119 8.76058 14.2264L9.28918 18.6533C9.33803 19.0624 9.83298 19.2401 10.131 18.9556L13.747 15.5025L17.977 19.9323C18.2631 20.2318 18.7379 20.2428 19.0374 19.9567C19.337 19.6707 19.3479 19.1959 19.0619 18.8963L14.8318 14.4666L18.448 11.0135C18.746 10.7289 18.5912 10.2263 18.1848 10.1587L13.787 9.42659C13.6802 9.40883 13.5822 9.35693 13.5074 9.27869L10.6578 6.29452C10.5662 6.19861 10.5165 6.07025 10.5195 5.93768L10.597 2.57982C10.6072 2.13449 10.074 1.89905 9.7518 2.20668L1.73435 9.86271C1.41219 10.1704 1.6228 10.7139 2.06813 10.7242L5.42599 10.8016ZM5.46057 9.30202L4.51628 9.28025L9.04172 4.95881L9.01995 5.9031C9.00772 6.43339 9.20665 6.94682 9.57297 7.33044L12.4226 10.3146C12.7215 10.6276 13.1138 10.8352 13.5406 10.9062L15.9656 11.3099L10.5415 16.4895L10.25 14.0485C10.1987 13.6188 10.0094 13.2174 9.71055 12.9044L6.8609 9.92026C6.49458 9.53663 5.99086 9.31425 5.46057 9.30202Z",
		fill: "currentColor"
	})
});
export { SvgIconPin as ReactComponent };
